import Scroll from 'controllers/Scroll';


export default class Utils {
	
	
	/**
	 * Promise deferred object
	 * ======================================================================
	 */
	static Deferred() {
		return new function () {
			this.resolve = null;
			this.reject  = null;
			
			this.promise = new Promise( ( resolve, reject ) => {
				this.resolve = resolve;
				this.reject  = reject;
			} );
		};
	}
	
	
	/**
	 * REMOVE HTTP FROM URL
	 * ======================================================================
	 */
	
	
	/*static stripString(url, disallowed) {
		for (let i = 0; i < disallowed.length; i++) {
			let disal = disallowed[i];
			if (url.indexOf(disal) === 0) {
				return url.replace(disal, '');
			}
		}

		return url;
	}*/
	
	
	/**
	 * String trim
	 * ======================================================================
	 */
	static trim( str, characters, flags ) {
		
		function escapeRegex( string ) {
			return string.replace( /[\[\](){}?*+\^$\\.|\-]/g, "\\$&" );
		}
		
		
		flags = flags || "g";
		if ( typeof str !== "string" || typeof characters !== "string" || typeof flags !== "string" ) {
			throw new TypeError( "argument must be string" );
		}
		
		if ( !/^[gi]*$/.test( flags ) ) {
			throw new TypeError( "Invalid flags supplied '" + flags.match( new RegExp( "[^gi]*" ) ) + "'" );
		}
		
		characters = characters.replace( /[\[\](){}?*+\^$\\.|\-]/g, "\\$&" );
		
		return str.replace( new RegExp( "^[" + characters + "]+|[" + characters + "]+$", flags ), '' );
	}
	
	
	/**
	 * Find a tag name in a node list
	 * ======================================================================
	 */
	static findParent( tagname, el ) {
		while ( el ) {
			if ( ( el.nodeName || el.tagName ).toLowerCase() === tagname.toLowerCase() ) {
				return el;
			}
			el = el.parentNode;
		}
		return null;
	}
	
	
	/**
	 * is function
	 * ======================================================================
	 */
	static isFunction( functionToCheck ) {
		let getType = {};
		return functionToCheck && getType.toString.call( functionToCheck ) === '[object Function]';
	}
	
	
	/**
	 * Get offset
	 * ======================================================================
	 */
	static offset( elt ) {
		let rect = elt.getBoundingClientRect();
		return {
			top:  rect.top + Scroll.yI,
			left: rect.left + Scroll.xI
		}
	}
	
	
	/**
	 * Shuffle an array
	 * ======================================================================
	 */
	static shuffle( array ) {
		let currentIndex = array.length,
			temporaryValue,
			randomIndex;
		
		// While there remain elements to shuffle...
		while ( 0 !== currentIndex ) {
			
			// Pick a remaining element...
			randomIndex = Math.floor( Math.random() * currentIndex );
			currentIndex -= 1;
			
			// And swap it with the current element.
			temporaryValue        = array[ currentIndex ];
			array[ currentIndex ] = array[ randomIndex ];
			array[ randomIndex ]  = temporaryValue;
		}
		
		return array;
	}
	
	
	/**
	 * Wrap
	 * ======================================================================
	 */
	static wrap( el, wrapper ) {
		el.parentNode.insertBefore( wrapper, el );
		wrapper.appendChild( el );
	}
	
	
	/**
	 * Wrap inner
	 * ======================================================================
	 */
	static wrapInner( parent, wrapper ) {
		parent.appendChild( wrapper );
		while ( parent.firstChild !== wrapper ) {
			wrapper.appendChild( parent.firstChild );
		}
	}
	
	
	/**
	 * Find closest match in array
	 * ======================================================================
	 */
	static closestValueInArray( search, values ) {
		let currentValue = values[ 0 ];
		let diff         = Math.abs( search - currentValue );
		for ( let index = 0; index < values.length; index++ ) {
			let newdiff = Math.abs( search - values[ index ] );
			if ( newdiff < diff ) {
				diff         = newdiff;
				currentValue = values[ index ];
			}
		}
		return currentValue;
	}
	
	
	/**
	 * Find closest match in array, returns index
	 * ======================================================================
	 */
	static closestIndexInArray( search, values ) {
		let currentValue = values[ 0 ],
			currentIndex = 0;
		let diff         = Math.abs( search - currentValue );
		for ( let index = 0; index < values.length; index++ ) {
			let newdiff = Math.abs( search - values[ index ] );
			if ( newdiff < diff ) {
				diff         = newdiff;
				currentValue = values[ index ];
				currentIndex = index;
			}
		}
		return currentIndex;
	}
	
	
	static getPointOnCircle( centerX, centerY, radius, angle ) {
		return {
			x: radius * Math.cos( angle ) + centerX,
			y: radius * Math.sin( angle ) + centerY
		};
	}
	
	
	static getPointOnEllipse( centerX, centerY, radiusX, radiusY, angle ) {
		var _x = centerX + ( radiusX * Math.cos( angle ) );
		var _y = centerY + ( radiusY * Math.sin( angle ) );
		return { x: _x, y: _y };
	}
	
	
	static shadeBlendConvert( _p, _from, _to ) {
		
		
		function sbcRip( d, i ) {
			var l   = d.length,
				RGB = {};
			if ( l > 9 ) {
				d = d.split( "," );
				if ( d.length < 3 || d.length > 4 ) {
					return null;
				}//ErrorCheck
				RGB[ 0 ] = i( d[ 0 ].slice( 4 ) ), RGB[ 1 ] = i( d[ 1 ] ), RGB[ 2 ] = i( d[ 2 ] ), RGB[ 3 ] = d[ 3 ] ? parseFloat( d[ 3 ] ) : -1;
			} else {
				if ( l === 8 || l === 6 || l < 4 ) {
					return null;
				} //ErrorCheck
				if ( l < 6 ) {
					d = "#" + d[ 1 ] + d[ 1 ] + d[ 2 ] + d[ 2 ] + d[ 3 ] + d[ 3 ] + ( l > 4 ? d[ 4 ] + "" + d[ 4 ] : "" );
				} //3 digit
				d = i( d.slice( 1 ), 16 ), RGB[ 0 ] = d >> 16 & 255, RGB[ 1 ] = d >> 8 & 255, RGB[ 2 ] = d & 255, RGB[ 3 ] = l == 9 || l == 5 ? r( ( ( d >> 24 & 255 ) / 255 ) * 10000 ) / 10000 : -1;
			}
			return RGB;
		}
		
		if ( typeof ( _p ) !== "number" || _p < -1 || _p > 1 || typeof ( _from ) !== "string" || ( _from[ 0 ] !== 'r' && _from[ 0 ] !== '#' ) || ( typeof ( _to ) !== "string" && typeof ( _to ) !== "undefined" ) ) {
			return null;
		} //ErrorCheck
		let i  = parseInt,
			r  = Math.round,
			h  = _from.length > 9,
			b  = _p < 0,
			p  = b ? _p * -1 : _p,
			to = _to && _to !== "c" ? _to : b ? "#000000" : "#FFFFFF",
			f  = sbcRip( _from, i ),
			t  = sbcRip( to, i );
		h      = typeof ( to ) === "string" ? to.length > 9 ? true : to === "c" ? !h : false : h;
		if ( !f || !t ) {
			return null;
		} //ErrorCheck
		if ( h ) {
			return "rgb(" + r( ( t[ 0 ] - f[ 0 ] ) * p + f[ 0 ] ) + "," + r( ( t[ 1 ] - f[ 1 ] ) * p + f[ 1 ] ) + "," + r( ( t[ 2 ] - f[ 2 ] ) * p + f[ 2 ] ) + ( f[ 3 ] < 0 && t[ 3 ] < 0 ? ")" : "," + ( f[ 3 ] > -1 && t[ 3 ] > -1 ? r( ( ( t[ 3 ] - f[ 3 ] ) * p + f[ 3 ] ) * 10000 ) / 10000 : t[ 3 ] < 0 ? f[ 3 ] : t[ 3 ] ) + ")" );
		} else {
			return "#" + ( 0x100000000 + ( f[ 3 ] > -1 && t[ 3 ] > -1 ? r( ( ( t[ 3 ] - f[ 3 ] ) * p + f[ 3 ] ) * 255 ) : t[ 3 ] > -1 ? r( t[ 3 ] * 255 ) : f[ 3 ] > -1 ? r( f[ 3 ] * 255 ) : 255 ) * 0x1000000 + r( ( t[ 0 ] - f[ 0 ] ) * p + f[ 0 ] ) * 0x10000 + r( ( t[ 1 ] - f[ 1 ] ) * p + f[ 1 ] ) * 0x100 + r( ( t[ 2 ] - f[ 2 ] ) * p + f[ 2 ] ) ).toString( 16 ).slice( f[ 3 ] > -1 || t[ 3 ] > -1 ? 1 : 3 );
		}
	}
	
	
	static curveThroughPoints( points, ctx ) {
		let i,
			n,
			a,
			b,
			x,
			y;
		
		// Remove start and end from the array
		for ( i = 1, n = points.length - 2; i < n; i++ ) {
			
			a = points[ i ];
			b = points[ i + 1 ];
			
			x = ( a.x + b.x ) * 0.5;
			y = ( a.y + b.y ) * 0.5;
			
			ctx.quadraticCurveTo( a.x, a.y, x, y );
		}
		
		a = points[ i ];
		b = points[ i + 1 ];
		ctx.quadraticCurveTo( a.x, a.y, b.x, b.y );
	}
	
	
}

